import { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supportApi } from '../lib/supportApi';
import { collectClientContext } from '../lib/clientContext';

export default function SupportThread() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [reply, setReply] = useState('');
  const [sending, setSending] = useState(false);

  const load = useCallback(() => {
    supportApi.get(id).then(setData).catch((e) => setError(e.message));
  }, [id]);
  useEffect(() => { load(); }, [load]);

  async function send() {
    const body = reply.trim();
    if (!body || sending) return;
    setSending(true);
    try {
      const { appVersion } = await collectClientContext();
      await supportApi.reply(id, body, { appVersion });
      setReply('');
      load();
    } catch (e) { setError(e.message); } finally { setSending(false); }
  }

  if (error) return <div style={{ maxWidth: 720, margin: '24px auto', padding: 16 }}><Link to="/account/support">← Support</Link><p style={{ color: '#b91c1c' }}>{error}</p></div>;
  if (!data) return <div style={{ maxWidth: 720, margin: '24px auto', padding: 16 }}>Loading…</div>;

  return (
    <div style={{ maxWidth: 720, margin: '24px auto', padding: 16 }}>
      <Link to="/account/support" style={{ fontSize: 13 }}>← Support</Link>
      <h1 style={{ fontSize: 20, marginTop: 8 }}>{data.ticket.subject}</h1>
      <div style={{ fontSize: 12, color: '#888', textTransform: 'capitalize', marginBottom: 16 }}>Status: {data.ticket.status}</div>
      {(data.messages || []).map((m) => (
        <div key={m.id} style={{ padding: 12, margin: '8px 0', borderRadius: 8, background: m.sender === 'admin' ? '#eef2ff' : '#f9fafb', border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>{m.sender === 'admin' ? 'Scrivar Support' : 'You'} · {new Date(m.created_at).toLocaleString()}</div>
          <div style={{ whiteSpace: 'pre-wrap', fontSize: 14, color: '#222' }}>{m.body}</div>
        </div>
      ))}
      {data.ticket.status !== 'closed' && (
        <div style={{ marginTop: 16 }}>
          <textarea value={reply} onChange={(e) => setReply(e.target.value)} rows={4} placeholder="Write a reply…"
            style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #d1d5db' }} />
          <button onClick={send} disabled={sending || !reply.trim()} style={{ marginTop: 8 }}>{sending ? 'Sending…' : 'Send reply'}</button>
        </div>
      )}
    </div>
  );
}
